import { IonIcon } from '@ionic/react'
import { useGate, useStore } from 'effector-react'
import { create, documentText } from 'ionicons/icons'
import { formatDateForUI } from '~/shared/lib/date'
import { Button } from '~/shared/ui/Buttons'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { Card, TitleWrapper } from '../styled'
import {
  Gate,
  $offer,
  fetchLatestPublicOfferFx,
  loadSignOffer,
  loadSignOfferFx,
} from './mode'
import { ButtonsWrapper, ConfirmedAt, Title } from './styled'

export function DocumentOffer() {
  useGate(Gate)

  const offer = useStore($offer)
  const isFetchOfferPending = useStore(fetchLatestPublicOfferFx.pending)
  const isLoadSignOfferPending = useStore(loadSignOfferFx.pending)
  const confirmedAt = offer?.getConfirmedAt()

  return (
    <Card data-testid='document-offer-block'>
      <TitleWrapper>
        <Title>Оферта</Title>

        {confirmedAt && (
          <ConfirmedAt data-testid='document-offer-date'>
            От {formatDateForUI(confirmedAt)}
          </ConfirmedAt>
        )}
      </TitleWrapper>

      {!isFetchOfferPending && !offer && <div>Документов нет</div>}

      {isFetchOfferPending && <Skeleton animated $height={32} />}

      {!isFetchOfferPending && offer && (
        <ButtonsWrapper data-testid='document-offer'>
          <Button
            loading={isLoadSignOfferPending}
            variant='lightSteelBlueBorder'
            onClick={() => loadSignOffer()}
            endDecorator={
              <IonIcon
                icon={create}
                style={{ width: '16px', height: '16px' }}
              />
            }
            contentProps={{ style: { padding: '8px' } }}
          >
            Подпись
          </Button>

          <Button
            variant='limeFlooded'
            href={offer?.getDocumentFileLink() as string}
            target='_blank'
            endDecorator={
              <IonIcon
                icon={documentText}
                style={{ width: '16px', height: '16px' }}
              />
            }
            contentProps={{ style: { padding: '8px' } }}
          >
            Оферта
          </Button>
        </ButtonsWrapper>
      )}
    </Card>
  )
}
